<template>
  <div id="top-header">
    <!--    <dv-decoration-8 class="header-left-decoration" />-->
    <!--    <dv-decoration-5 class="header-center-decoration" />-->
    <!--    <dv-decoration-8 class="header-right-decoration" :reverse="true" />-->
    <div class="left-logo"><img src="./img/logo_login.png"></div>
    <div class="center-title">商储物流绿色城市配送平台</div>
    <div class="right-time">{{nowTime}}</div>
  </div>
</template>

<script>
    export default {
        name: 'TopHeader',
        data() {
            return {
                nowTime: '加载中。。。'
            }
        }, created() {
            this.initTime();
        },
        methods: {
            initTime() {
                setInterval(this.getTime, 1000);
            },
            getTime() {
                var myDate = new Date();
                var myYear = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
                var myMonth = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
                var myToday = myDate.getDate(); //获取当前日(1-31)
                var myDay = myDate.getDay(); //获取当前星期X(0-6,0代表星期天)
                var myHour = myDate.getHours(); //获取当前小时数(0-23)
                var myMinute = myDate.getMinutes(); //获取当前分钟数(0-59)
                var mySecond = myDate.getSeconds(); //获取当前秒数(0-59)
                var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
                var nowTime;

                this.nowTime = myYear + '-' + this.fillZero(myMonth) + '-' + this.fillZero(myToday) + '  ' + week[myDay] + '  ' + this.fillZero(myHour) + ':' + this.fillZero(myMinute) + ':' + this.fillZero(mySecond);
            },
            fillZero(str){
                var realNum;
                if(str<10){
                    realNum	= '0'+str;
                }else{
                    realNum	= str;
                }
                return realNum;
            }
        }
    }
</script>

<style lang="less">
  #top-header {
    position: relative;
    width: 100%;
    height: 65px;
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;

    .header-center-decoration {
      width: 40%;
      height: 60px;
      margin-top: 30px;
    }

    .header-left-decoration, .header-right-decoration {
      width: 25%;
      height: 60px;
    }

    .left-logo {
      font-size: 30px;
      line-height: 60px;
      font-weight: bold;
      padding-left: 2%;

      img{
        height: 60px;
      }
    }


    .right-time {
      font-size: 20px;
      line-height: 60px;
      padding-right: 2%;
    }

    .center-title {
      position: absolute;
      font-size: 30px;
      font-weight: bold;
      left: 50%;
      top: 15px;
      transform: translateX(-50%);
    }
  }
</style>
